export default "__VITE_ASSET__C1vs1UuA__"